// helper function to remove all child nodes
export default function( node ) {
	if ( node && node.firstChild ) {
		while(node.firstChild) {
			node.removeChild(node.firstChild);
		}
	}
}
